export enum EPageMode {
  Auth = 'auth',
  BecomeProfessional = 'becomeProfessional',
}

export interface IPageState {
  mode: EPageMode;
  userId?: number;
  returnUrl?: string;
  subdomain?: string;
}
